export default "__VITE_ASSET__EIB63xaF__"